import TryNow from './TryNow';

export default TryNow;
